<template>
<div id="calculator-banner"
class="flex items-center justify-center min-h-[500px] relative">
  <img src="../assets/images/banner/banner-calculator-green.webp"
  alt="Arena Points Calculator Background"
  class="absolute inset-0 w-full h-full object-cover"
  loading="lazy"
  >
  <div class="max-w-5xl w-full text-center relative z-10">

    <!-- TITLE -->
    <h1 class="text-4xl md:text-6xl font-bold tracking-wider text-shadow-wow font-morpheus
    text-wow-gold hero-title">
      <span class="text-5xl md:text-7xl">A</span>rena
       <span class="text-5xl md:text-7xl">P</span>OINTS
    </h1>

    <p class="mt-2 text-2xl md:text-7xl font-bold tracking-wider
    text-wow-gold font-morpheus hero-title">
      Calculator
    </p>

    <!-- SUBTITLE -->
    <p class="mt-6 text-gray-300 text-lg md:text-3xl shadow-2xl
     max-w-lg mx-auto font-cormorant">
      Calculate your exact weekly arena points based on rating and bracket.
    </p>
  </div>
</div>
</template>

<script setup>
</script>

<style scoped>
@import '../assets/styles/main.css';

</style>
